import { DataListHeader, Panel } from 'mailup-web-components'
import { changeColumnsOrderCallback } from 'Pages/WorkflowsList/recoil/callbacks/callbacks'
import { pageState } from 'Pages/WorkflowsList/recoil/state/page'
import { orderingState } from 'Pages/WorkflowsList/recoil/state/search'
import PropTypes from 'prop-types'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import Pagination from './Pagination'
import Row from './Row'
import RowsPlaceholder from './RowsPlaceholder'

const Results = ({ items }) => {
  const intl = useIntl()

  const { fetchingResults } = useRecoilValue(pageState)
  const handleChangeColumnsOrder = useRecoilCallback(changeColumnsOrderCallback)

  const { orderBy, orderDescending } = useRecoilValue(orderingState)

  const heads = [
    {
      field: 'Name',
      label: intl.formatMessage({
        id: 'Load.AutomationWorkflow.ListTableWorkflowNameNew'
      }),
      span: 3,
      sortable: true
    },
    {
      field: 'Type',
      label: intl.formatMessage({
        id: 'Load.AutomationWorkflow.ListTableType'
      }),
      span: 2
    },
    {
      field: 'LastModifiedDate',
      label: intl.formatMessage({
        id: 'Load.AutomationWorkflow.LastUpdate'
      }),
      span: 2,
      sortable: true
    },
    {
      field: 'LastActivationDate',
      label: intl.formatMessage({
        id: 'Load.AutomationWorkflow.LastActivation'
      }),
      span: 3,
      sortable: true
    },
    {
      field: 'Enabled',
      label: intl.formatMessage({
        id: 'Load.AutomationWorkflow.ListTableStatus'
      }),
      span: 2
    }
  ]
  const COLUMN_AFTER_WIDTH = '30px'

  return (
    <>
      {items && (
        <Panel>
          <DataListHeader
            heads={heads}
            afterWidth={COLUMN_AFTER_WIDTH}
            orderByStatus={orderBy}
            orderDescendingStatus={orderDescending}
            handleChangeColumnsOrderCallback={handleChangeColumnsOrder}
          />
          <div>
            {fetchingResults ? (
              <RowsPlaceholder heads={heads} afterWidth={COLUMN_AFTER_WIDTH} />
            ) : (
              items.map((item, key) => {
                return <Row key={key} item={item} heads={heads} />
              })
            )}
          </div>
          <Pagination />
        </Panel>
      )}
    </>
  )
}

export default Results

Results.propTypes = {
  items: PropTypes.array
}
